import Profile from '@/components/Profile'
import { Button } from '@/components/ui/button'
import { useFetchProfile } from '@/hooks/useFetchProfile'
import SecondaryPageLayout from '@/layouts/SecondaryPageLayout'
import { usePrimaryPage } from '@/PageManager'
import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowUpRight01Icon } from '@hugeicons/core-free-icons'
import { forwardRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAtomValue } from 'jotai'
import { isSmallScreenAtom } from '@/atoms/screenSize'

const ProfilePage = forwardRef(({ id, index }: { id: string; index?: number }, ref) => {
  const { t } = useTranslation()
  const { profile } = useFetchProfile(id)
  const { navigate } = usePrimaryPage()
  const isSmallScreen = useAtomValue(isSmallScreenAtom)

  useEffect(() => {
    if (!profile) return

    const shortAuthor =
      profile.shortName.length > 12
        ? profile.shortName.slice(0, 11).trim() + '…'
        : profile.shortName
    document.title = t('{{shortAuthor}} on {{appName}}', {
      shortAuthor,
      appName: window.hallway.universe.appName
    })
  }, [profile, id])

  return (
    <SecondaryPageLayout
      index={index}
      title={profile?.shortName ?? ''}
      displayScrollToTopButton
      ref={ref}
      controls={
        !isSmallScreen && (
          <Button
            variant="ghost"
            size="titlebar-icon"
            onClick={() => navigate('profile', { id })}
            title={t('Open in primary panel')}
          >
            <HugeiconsIcon icon={ArrowUpRight01Icon} />
          </Button>
        )
      }
    >
      <Profile id={id} withPaymentTargets />
    </SecondaryPageLayout>
  )
})
ProfilePage.displayName = 'ProfilePage'
export default ProfilePage
